import store from '../index'

export const dispatchError = (error) => {
  store.dispatch({ type: 'DISPATCH_ERROR', error })
}

export const dispatchMessage = (message) => {
  store.dispatch({ type: 'DISPATCH_MESSAGE', message })
}
